//Docs on https://next-intl-docs.vercel.app/docs/routing/navigation#link
import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'
import { defaultLanguage, supportedLanguages } from 'cf-i18n/constants'

const routing = defineRouting({
  locales: supportedLanguages,
  defaultLocale: defaultLanguage,
  localePrefix: 'as-needed', //this should match the value in middleware.ts
})

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing)
